import { useAuthContext } from '@/context/AuthContext.tsx';
import Routes from '@/router/Routes.ts';
import Middleware from '@/router/middleware/index.tsx';
import { FC } from 'react';
import { Navigate, Outlet } from 'react-router-dom';

const IsAdmin: FC = () => {
  const { isLoading, user, session, isAdmin } = useAuthContext();

  if (isLoading) {
    return <Middleware isLoading />;
  }

  if (!session) {
    return <Navigate to={Routes.LOGIN} replace />;
  }

  if (!user) {
    return <Navigate to={Routes.CALLBACK_AUTH} replace />;
  }

  if (!isAdmin) {
    return <Navigate to={Routes.GYMS} replace />;
  }

  return <Outlet />;
};

export default IsAdmin;
